import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, Alert } from "reactstrap"
import { get } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "common/loader";
import { FAQ_LIST } from "helpers/api_endpoints";
//meta title
document.title = "faqs List";
const FaqList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [faqs, setfaqs] = useState([]);
    const [successMsg, setsuccessMsg] = useState('');

    useEffect(() => {
        successMessage();
        get(FAQ_LIST)
            .then(response => {
                const data = response.data;
                setfaqs(data);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 401) {
                    navigate('/login');
                }
            })
    }, []);


    const successMessage = () => {
        if (location.state) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                setsuccessMsg('');
            }, 4000)
        }
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="FAQs" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <br></br>
                                {successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
                                <Link to="/faqs/add" >
                                    <button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
                                </Link>
                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th><Trans>Id</Trans></th>
                                                    <th><Trans>Question</Trans></th>
                                                    <th><Trans>Answer</Trans></th>
                                                    <th>#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? <tr><th colSpan={6} className="text-center"><Loader></Loader></th></tr> : null}
                                                {
                                                    faqs.map((faq, index) => (
                                                        <tr key={index}>
                                                            <td>{faq.id}</td>
                                                            <td>{faq.name}</td>
                                                            <td>{faq.value}</td>
                                                            <td><Link to={{ pathname: `/faqs/update/${faq.id}` }} state={faq}><button className="btn btn-sm btn-info"><i className="dripicons-pencil"></i> &nbsp;<Trans>Update</Trans></button></Link> &nbsp;
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}

export default FaqList
